import React from "react";

const NotFound = () => (
  <div>
      NOT FOUND
  </div>
);
export default NotFound;